import { RemoteScheduledPushNotificationList } from 'data/usecases';
import { ScheduledPushNotificationListUseCaseInterface } from 'domain/usecases';
import { makeApiUrlScheduledPushNotificationList } from 'main/factories/http/api-url-factory';
import { makeAxiosHttpClient } from 'main/factories/http/axios-http-client-factory';

export const makeScheduledPushNotificationList =
  (): ScheduledPushNotificationListUseCaseInterface =>
    new RemoteScheduledPushNotificationList(
      makeApiUrlScheduledPushNotificationList(),
      makeAxiosHttpClient(),
    );
